"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var store_1 = require("../store");
var core_1 = require("../core");
exports.FlaggContext = react_1.default.createContext({
    featureFlags: core_1.flagg({ store: store_1.inMemoryStore() }),
    iteration: 0
});
//# sourceMappingURL=context.js.map